import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const taglines = ["Trusted By Best", "Chosen By Industry", "Proven By Results"];

const TextRotator = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % taglines.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-center relative  h-[5.5rem] overflow-hidden leading-[1.2]">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.6 }}
          className="absolute w-full"
        >
          <h2 className="text-3xl p-2 md:text-5xl tracking-wide font-bold text-secondary-gradient bg-clip-text text-transparent font-inter">
            {taglines[index]}
          </h2>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default TextRotator;
